/**
 * Pure function — given a cell index (1..64), return the reading from data.
 */
export default function deriveGaneshaReading(cellIndex, data) {
  if (!Number.isInteger(cellIndex) || cellIndex < 1 || cellIndex > 64) {
    throw new RangeError(`cellIndex must be an integer in [1, 64], got ${cellIndex}`);
  }
  const response = data.responses[cellIndex - 1];
  if (!response || typeof response.syllable !== 'string') {
    throw new Error(`responses[${cellIndex - 1}] is missing or malformed`);
  }
  return response;
}
